module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0014.jpg?v=c49850be";